import * as Selectors from '../../store/selectors';
import { useDispatch, useSelector } from './redux';
import * as Hooks from 'preact/hooks';
import * as Arya from '../arya';
import { AryaEvent } from '@digital-bridge/artisan-arya';
import * as FurnitureListStore from '../../store/furnitureList';
import * as O from 'fp-ts/Option';
import { FurnitureItem } from '../../data/furniture';

// TODO: Use io-ts for more ergonomic unknown -> useful type conversion
const hasFurnitureIdString = (data: unknown): data is { furnitureId: string } =>
    typeof data === 'object' &&
    data !== null &&
    data.hasOwnProperty('furnitureId') &&
    typeof (data as any).furnitureId === 'string';

/**
 * Create a list of FurnitureItem Entries based on the current state of Arya and a FurnitureMap
 */
export const useFurnitureList = (arya: O.Option<Arya.Interface>) => {
    const furniture = useSelector(Selectors.FurnitureList.furnitureListWithProducts);
    const dispatch = useDispatch();

    Hooks.useEffect(() => {
        // NOTE that adding furniture to the list is handled where furniture is added, as it needs more
        //      information than is available here
        const handler = (data: unknown) => {
            if (hasFurnitureIdString(data)) {
                dispatch(FurnitureListStore.removeFurnitureByAryaId(data.furnitureId));
            }
        };

        const mArya = O.toNullable(arya);

        mArya?.on(AryaEvent.FURNITURE_DELETED, handler);

        return () => mArya?.off(AryaEvent.FURNITURE_DELETED, handler);
    }, [arya]);

    return furniture;
};
